import React, { useRef } from 'react'
import styled from 'styled-components'
import { Container, Wrapper, Title, TitleUnderline, CarouselRow, CardContainer } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'
import { RoughUnderline, RoughCircle } from '../common/Rough'
import { ChalkDoodles } from '../common/Doodles'

const ArrowButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  font-family: 'Kalam', cursive;
  font-weight: 700;
  font-size: 22px;
  color: ${({ theme }) => theme.text_primary};
  transition: transform 0.15s ease;
  &:hover {
    transform: scale(1.1);
    color: ${({ theme }) => theme.primary};
  }
  @media (max-width: 640px) {
    display: none;
  }
`;

const SCROLL_AMOUNT = 358;

const Projects = ({ openModal, setOpenModal }) => {
  const trackRef = useRef(null);

  const scroll = (dir) => {
    trackRef.current?.scrollBy({ left: dir * SCROLL_AMOUNT, behavior: 'smooth' });
  };

  return (
    <Container id="projects">
      <ChalkDoodles seedBase={23} count={9} />
      <Wrapper>
        <Title>Projects</Title>
        <TitleUnderline>
          <RoughUnderline height={16} strokeWidth={3.5} />
        </TitleUnderline>

        <CarouselRow>
          <ArrowButton onClick={() => scroll(-1)} aria-label="Previous projects">
            <RoughCircle size={40} strokeWidth={1.6} roughness={2.4}>‹</RoughCircle>
          </ArrowButton>

          <CardContainer ref={trackRef}>
            {projects.map((project, index) => (
              <ProjectCard key={project.id} project={project} flip={index % 2 === 0} openModal={openModal} setOpenModal={setOpenModal} />
            ))}
          </CardContainer>

          <ArrowButton onClick={() => scroll(1)} aria-label="Next projects">
            <RoughCircle size={40} strokeWidth={1.6} roughness={2.4}>›</RoughCircle>
          </ArrowButton>
        </CarouselRow>
      </Wrapper>
    </Container>
  )
}

export default Projects
